import React from "react";
import { Navigate } from "react-router-dom";

import { useSmartRouteResolution } from "./smart-routes/useSmartRouteResolution";

const RetailDashboardPage = React.lazy(() => import("@/features/retail/pages/RetailDashboardPage.V3"));

const RetailDashboardFallback = () => (
  <div className="flex min-h-[320px] items-center justify-center rounded-2xl border border-slate-200/60 bg-white/95 px-6 py-12 text-center shadow-sm dark:border-slate-800/50 dark:bg-slate-950/70">
    <div>
      <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">Loading retail workflows…</p>
      <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
        Preparing a personalized storefront workspace for your team.
      </p>
    </div>
  </div>
);

const LEGACY_REDIRECTS: Record<string, string> = {
  "/retail": "retail",
};

export const SmartRetailDashboardRoute: React.FC = () => {
  const resolution = useSmartRouteResolution({
    routeKey: "retail",
    legacyRedirects: LEGACY_REDIRECTS,
    allowDemoWithoutAuth: true,
  });

  if (resolution.redirectPath) {
    return <Navigate to={resolution.redirectPath} replace />;
  }

  return (
    <React.Suspense fallback={<RetailDashboardFallback />}>
      <RetailDashboardPage />
    </React.Suspense>
  );
};

export default SmartRetailDashboardRoute;
